import { useLazyQuery } from "@apollo/client";
import {
  GET_OTTO_ANALYTICS_SUMMARY,
  GET_OTTO_MESSAGE_STATISTICS,
  GET_OTTO_APPOINTMENT_STATISTICS,
  GET_VEHICLE_TRADE_OVERVIEW,
  GET_CAMPAIGN_STATISTICS,
  GET_OTTO_ACTIVITIES,
  GET_RESPONSE_TIME_ANALYSIS,
  GET_LEAD_INTERACTION_BY_OTTO,
  GET_OTTO_STATISTICS_SUMMARY,
  GET_OTTO_NOTES_DETAILS,
} from "../graphql/query";

/**
 * Custom hook that provides all Otto Analytics GraphQL queries
 * Can be used by both contexts (for shared data) and components (for single-use queries)
 *
 * @returns {Object} Object containing all query functions and their states
 */
const useOttoAnalyticsQueries = () => {
  // Analytics Summary Query
  const [fetchAnalyticsSummary, analyticsSummaryQuery] = useLazyQuery(GET_OTTO_ANALYTICS_SUMMARY);

  // Message Statistics Query
  const [fetchMessageStatistics, messageStatisticsQuery] = useLazyQuery(
    GET_OTTO_MESSAGE_STATISTICS
  );

  // Appointment Statistics Query
  const [fetchAppointmentStatistics, appointmentStatisticsQuery] = useLazyQuery(
    GET_OTTO_APPOINTMENT_STATISTICS
  );

  // Vehicle Trade Overview Query
  const [fetchVehicleTradeOverview, vehicleTradeOverviewQuery] = useLazyQuery(
    GET_VEHICLE_TRADE_OVERVIEW
  );

  // Campaign Statistics Query
  const [fetchCampaignStatistics, campaignStatisticsQuery] = useLazyQuery(GET_CAMPAIGN_STATISTICS);

  // Otto Activities Query
  const [fetchOttoActivities, ottoActivitiesQuery] = useLazyQuery(GET_OTTO_ACTIVITIES);

  // Response Time Analysis Query
  const [fetchResponseTimeAnalysis, responseTimeAnalysisQuery] = useLazyQuery(
    GET_RESPONSE_TIME_ANALYSIS
  );

  // Get Lead Interaction by Otto Query
  const [fetchLeadInteractionByOtto, leadInteractionByOttoQuery] = useLazyQuery(
    GET_LEAD_INTERACTION_BY_OTTO
  );

  // Get auto responder, campaign messages, after our engagements and call summarized metric data
  const [fetchEngagementMetrics, engagementMetricsQuery] = useLazyQuery(
    GET_OTTO_STATISTICS_SUMMARY
  );

  // Notes Details Query
  const [fetchNotesDetails, notesDetailsQuery] = useLazyQuery(GET_OTTO_NOTES_DETAILS);

  return {
    // Query functions
    fetchAnalyticsSummary,
    fetchMessageStatistics,
    fetchAppointmentStatistics,
    fetchVehicleTradeOverview,
    fetchCampaignStatistics,
    fetchOttoActivities,
    fetchResponseTimeAnalysis,
    fetchLeadInteractionByOtto,
    fetchEngagementMetrics,
    fetchNotesDetails,

    // Query states (for components that want to use them directly)
    analyticsSummaryQuery,
    messageStatisticsQuery,
    appointmentStatisticsQuery,
    vehicleTradeOverviewQuery,
    campaignStatisticsQuery,
    ottoActivitiesQuery,
    responseTimeAnalysisQuery,
    leadInteractionByOttoQuery,
    engagementMetricsQuery,
    notesDetailsQuery,
  };
};

export default useOttoAnalyticsQueries;
